export default from './InputQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/InputQuestion/index.js